import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { saveWorkspaceReportSettingsBodySchema } from "@common/schemas/domains/reportSettings/save-report-settings.schema";
import { WorkspacePathParamsSchema } from "@common/schemas/organization-service.schema";
import { workspaceReportSettingsResponseSchema } from "@common/schemas/domains/reportSettings/workspace-report-settings.schema";

const c = initContract();

export const reportSettingsContract = c.router(
    {
        getWorkspaceReportSettings: {
            method: "GET",
            path: "/workspaces/:workspaceId",
            pathParams: WorkspacePathParamsSchema,
            responses: {
                200: workspaceReportSettingsResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        updateWorkspaceReportSettings: {
            method: "PATCH",
            path: "/workspaces/:workspaceId",
            pathParams: WorkspacePathParamsSchema,
            body: saveWorkspaceReportSettingsBodySchema,
            responses: {
                200: z.void(),
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/report-settings",
    },
);
